module.exports = __webpack_public_path__ + "static/media/icon-12.d8e8ccb8.png";